var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2047_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7275 12.4689C12.4941 13.0279 12.2179 13.5424 11.8978 14.0155C11.4615 14.6604 11.1042 15.1068 10.8289 15.3547C10.4021 15.7616 9.94482 15.97 9.45515 15.9818C9.10362 15.9818 8.67969 15.8781 8.18621 15.6678C7.69111 15.4584 7.23612 15.3547 6.82009 15.3547C6.38378 15.3547 5.91583 15.4584 5.4153 15.6678C4.91401 15.8781 4.51018 15.9878 4.20142 15.9986C3.73186 16.0194 3.26381 15.8051 2.79663 15.3547C2.49845 15.0851 2.12548 14.6229 1.67868 13.9681C1.1993 13.2688 0.805188 12.458 0.496431 11.5336C0.165763 10.5351 0 9.5682 0 8.63213C0 7.55987 0.223494 6.63506 0.671149 5.86007C1.02297 5.23757 1.49101 4.74652 2.0768 4.38604C2.66259 4.02556 3.29554 3.84186 3.97717 3.83011C4.35013 3.83011 4.83923 3.94971 5.44703 4.18476C6.05311 4.42061 6.44227 4.54021 6.61289 4.54021C6.74045 4.54021 7.17277 4.40036 7.90565 4.12156C8.59871 3.863 9.18364 3.75594 9.66283 3.79811C10.9613 3.90675 11.9368 4.4374 12.5856 5.39342C11.4243 6.12288 10.8498 7.14458 10.8613 8.45525C10.8718 9.47616 11.229 10.3257 11.9311 11.0003C12.2493 11.3133 12.6046 11.5553 13 11.7272C12.9143 11.9849 12.8238 12.2318 12.7275 12.4689ZM9.74953 0.320091C9.74953 1.12027 9.46754 1.8674 8.90547 2.55894C8.22717 3.38103 7.40674 3.85608 6.51705 3.78112C6.50572 3.68512 6.49914 3.58409 6.49914 3.47792C6.49914 2.70975 6.82171 1.88765 7.39455 1.21547C7.68054 0.875136 8.04426 0.592152 8.48534 0.36641C8.92547 0.144037 9.34179 0.0210594 9.73333 0C9.74476 0.106972 9.74953 0.213961 9.74953 0.320091Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2047_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f68cb94996c8e7c4dfd8465785d63948.svg";
export { ForwardRef as ReactComponent };